import { type RumInitConfiguration } from "@datadog/browser-rum-core";

export const datadogRumConfig: RumInitConfiguration = {
  applicationId: "503c6293-5548-4ff0-b3fb-ca324b0d8987",
  clientToken: "pub1dd57b604ca36ac19960ca0b3913c473",
  site: "datadoghq.eu",
  service: "staff-app",
  env: process.env.MODE,
  // The version is used for source map upload and version tag in the RUM explorer.
  version: process.env.APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "allow",
  // allows global and user context to be preserved after page reload, and syncronized across tabs on the same origin
  // this is used for tracking the user & their preference across pages.
  storeContextsAcrossPages: true,
};
